import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Providers } from './components/Providers';
import { ProblemSection } from './components/ProblemSection';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { UseCases } from './components/UseCases';
import { Pricing } from './components/Pricing';
import { Security } from './components/Security';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // PostHog Initialization - inject script tag
    if (document.getElementById('posthog-script')) return;
    const script = document.createElement('script');
    script.id = 'posthog-script';
    script.async = true;
    script.innerHTML = `
      !function(t,e){var o,n,p,r;e.__SV||(window.posthog&&window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias set_config startSessionRecording stopSessionRecording opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing reset register register_once unregister getFeatureFlag isFeatureEnabled onFeatureFlags reloadFeatureFlags group getGroups get_distinct_id get_session_id get_session_replay_url".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
      posthog.init('phc_yvw3Fkd39yoGS56M9ZEWYVmeJeXNgJSbBuuyuq7hd2vf',{api_host:'https://us.i.posthog.com',person_profiles:'identified_only'});
    `;
    document.head.appendChild(script);
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 antialiased selection:bg-blue-100 selection:text-blue-900" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Providers data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <Features data-id="element-7" />
        <UseCases data-id="element-8" />
        <Pricing data-id="element-9" />
        <Security data-id="element-10" />
        <FAQ data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}